import { collection, onSnapshot } from "firebase/firestore";
import firebaseInit from "../../firebase";

export const subscribeToVerifiedUsers = (setIsLoading, onUpdate) => {
  setIsLoading(true);
  const colRef = collection(firebaseInit.firestore, "verified_users");

  const unsubscribe = onSnapshot(
    colRef,
    (snapshot) => {
      const users = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      onUpdate(users);
      setIsLoading(false);
    },
    (err) => {
      console.error("Failed to subscribe to verified users:", err);
      setIsLoading(false);
    },
  );

  return unsubscribe;
};
